<template>
  <div @click="generate" v-if="hasData">
    <slot>
      <v-tooltip location="bottom" :text="$t('Export')">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" icon="mdi-tray-arrow-down" @click.prevent></v-btn>
        </template>
      </v-tooltip>
    </slot>
  </div>
</template>

<script>
import Papa from 'papaparse'
import downloadFile from '@/common/downloadFile'

export default {
  name: 'CsvExport',
  props: {
    data: {
      type: Array,
      default: null
    },
    fileName: {
      type: String,
      default: 'data.csv'
    },
    exportConfig: {
      type: Object,
      required: false
    },
    printHeaderRow: {
      type: Boolean,
      required: false,
      default: true
    },
    hasBeforeGenerateEvent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    hasData() {
      return this.data.length > 0
    }
  },
  methods: {
    generate: function () {
      if (this.hasBeforeGenerateEvent) {
        this.$emit('beforeGenerate', this.download)
      } else {
        this.$emit('beforeGenerate')
        this.download()
      }
    },
    download(data) {
      if (!data) {
        data = this.getFilteredFields()
      }
      const csvString = Papa.unparse(data, {
        header: this.printHeaderRow,
        skipEmptyLines: 'greedy',
        quotes: true
      })
      downloadFile(csvString, 'application/csv', this.fileName)
    },
    getFilteredFields() {
      // filter our data to the specified keys
      let keys = this.getKeys()

      let newData = []
      let _self = this
      this.data.map(function (item) {
        let newItem = {}
        for (let label in keys) {
          let config = keys[label]
          if (typeof config === 'object') {
            newItem[label] = _self.getValue(item, config.property, '', config.isDate)
          } else {
            newItem[label] = _self.getValue(item, config, '')
          }
        }
        newData.push(newItem)
      })
      return newData
    },
    getKeys() {
      // either export all or what's config'd in the exportConfig
      if (this.exportConfig) {
        return this.exportConfig
      }

      let keys = {}
      for (let key in this.data[0]) {
        keys[key] = key
      }
      return keys
    },
    getValue(object, path, defaultVal, isDate) {
      if (object === undefined || object === null || path === undefined || path === null) {
        return defaultVal
      }

      let names

      if (typeof path === 'string') {
        names = path.split('.').reverse()
      }

      while (names.length && (object = object[names.pop()]) !== undefined && object !== null);

      // Handle cases where accessing a childprop of a null value
      if (object === null && names.length) object = undefined

      if (object === undefined) {
        return defaultVal
      } else {
        if (isDate) {
          const date = new Date(object)
          return this.$filters.DateTimeFilter(date)
        }
        return object
      }
    },
    parseValue(value) {
      // convert null/undefined to empty string
      return value || value === 0 || typeof value === 'boolean' ? value : ''
    }
  }
}
</script>
